<template>
  <div>
    <div @click="execute()">
      <slot></slot>
    </div>
    <Modal v-if="isModal" :title="title" :width="450" :height="250" v-show="showModal(`confirmation${data.id}`)">
      <b-col sm="12">
        <div class="div-button text-center">
          <Button key="notConfirm" type="edit" title="Cancelar" :disabled="disabled" size="small" :clicked="cancel" />
          <Button key="confirm" :type="type" title="Sim, confirmar" size="medium" :disabled="disabled"
            :clicked="confirm" />
        </div>
      </b-col>
    </Modal>
    <div v-else class="div-button text-center">
      <Button _key="notConfirm" type="edit" title="Cancelar" size="small" :disabled="disabled" :clicked="cancel" />
      <Button _key="confirm" :type="type" title="Sim, confirmar" size="medium" :disabled="disabled"
        :clicked="confirm" />
    </div>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Confirmation",
  components: {
    Button,
    Modal,
  },
  props: {
    title: String,
    type: String,
    data: Object,
    isModal: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    confirmed: Function,
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading"]),
    execute() {
      this.openModal(`confirmation${this.data.id}`);
    },
    confirm() {
      let self = this;
      setTimeout(function () {
        if (self.confirmed) self.confirmed(self.data);
      }, 200);
    },
    cancel() {
      this.removeLoading(["notConfirm"]);
      this.hideModal();
    },
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
};
</script>
<style scoped>
.div-button {
  padding-top: 20px;
  height: 100px;
}
</style>
